import axios from 'axios';
import {CONFIG, URLS, getAccessToken, decryptPHI, getLoggedInData} from '../helpers/Common';


export const SURGEON = {
    login,
    getPendingPatientsNarrative,
    getPatientNarrativesDetails,
    getPatientDetail,
    getPatientOptionsDetail,
    approvedPatientNarrative,
    getPatientComplains,
    getPatientComplainDetail,
    getNarrativeQuestionsDetail,
    updatePatientNarrative,
    getAcceptedPatientsNarrative,
    searchQuestion,
    saveSearchQuestionOption,
    getAdditionalPatientNarrative,
    savePendingQuestion,
    getProfile,
    deleteAdditionalInfo,
};

function getPatientNarrativesDetails(narrative_id) { 
    // let data = new FormData();
    // data.append('token',getAccessToken());
    // data.append('narrative_id',narrative_id);
   // console.log('API HITS')
    let requestOptions = {
        method:'GET',
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        // data,
        url:`${CONFIG.API_URL+URLS.patient_narratives_details}/${narrative_id}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function decryptListResponse(AllData){
    if (AllData) 
    {
        for (let index = 0; index < AllData.length; index++) 
        {
            var DataObj = AllData[index];
            DataObj.title = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.title);
            DataObj.first_name = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.first_name);
            DataObj.last_name = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.last_name);
            DataObj.email = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.email);
            DataObj.phone = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.phone);
            DataObj.gender = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.gender);
            DataObj.narrative_summary = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.narrative_summary);
            DataObj.patient_additional_info = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.patient_additional_info);
            var date_of_birth = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.date_of_birth);
            
            var today = new Date(date_of_birth);
            var dd = today.getDate();
            var mm = today.getMonth()+1; 
            var yyyy = today.getFullYear();
            if(dd<10) 
            {
                dd='0'+dd;
            } 
            if(mm<10) 
            {
                mm='0'+mm;
            } 
            
            var formatted_date = mm+'/'+dd+'/'+yyyy;
            DataObj.date_of_birth = formatted_date;

            var all_complaintsSummry = DataObj.all_complaints;
            var extractSummry = JSON.parse(all_complaintsSummry);
             //console.log('here is all complain summary',extractSummry);
            var commonArray = new Array();
            for (let j = 0; j < extractSummry.length; j++) 
            {
                var allComplainsArray = extractSummry[j];
                var profileSummary = allComplainsArray['profileSummary'];
                profileSummary = decryptPHI(CONFIG.ENCRYPTION_KEY,profileSummary);
            //   console.log('decrypted profile summary',profileSummary)
                allComplainsArray['profileSummary'] = profileSummary;
                commonArray[j] = allComplainsArray;
            }
            DataObj.all_complaints = JSON.stringify(commonArray);
            
        }   
        return AllData;
    }
}
function decryptDetailResponse(AllData){
    if (AllData) 
    { 
        var DataObj = AllData;
        DataObj.title = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.title);
        DataObj.first_name = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.first_name);
        DataObj.last_name = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.last_name);
        DataObj.email = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.email);
        DataObj.phone = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.phone);
        DataObj.gender = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.gender);
        var date_of_birth = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.date_of_birth);
        DataObj.narrative_summary = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.narrative_summary);
        DataObj.patient_additional_info = decryptPHI(CONFIG.ENCRYPTION_KEY,DataObj.patient_additional_info);
        
        var today = new Date(date_of_birth);
        var dd = today.getDate();
        var mm = today.getMonth()+1; 
        var yyyy = today.getFullYear();
        if(dd<10) 
        {
            dd='0'+dd;
        } 
        if(mm<10) 
        {
            mm='0'+mm;
        } 
        
        var formatted_date = mm+'/'+dd+'/'+yyyy;
        DataObj.date_of_birth = formatted_date;

        var all_complaintsSummry = DataObj.all_complaints;
        var extractSummry = JSON.parse(all_complaintsSummry);
        var commonArray = new Array();
        for (let j = 0; j < extractSummry.length; j++) 
        {
            var allComplainsArray = extractSummry[j];
            var profileSummary = allComplainsArray['profileSummary'];
            profileSummary = decryptPHI(CONFIG.ENCRYPTION_KEY,profileSummary);
            allComplainsArray['profileSummary'] = profileSummary;
            commonArray[j] = allComplainsArray;
        }
        DataObj.all_complaints = JSON.stringify(commonArray);
        
        return DataObj;
    }
}
async function getPendingPatientsNarrative(surgeon_id , currentPage) {
    let data = new FormData();
    //data.append('token',getAccessToken());
    // data.append('surgeon_id',surgeon_id);
    // data.append('currentPage',currentPage);
    // data.append('offset',currentPage);
    // data.append('limit',CONFIG.RECORDS_PER_PAGE);
    let userData = getLoggedInData();
    let clinic_id = userData.clinic_id;
    let requestOptions = {
        method:'GET',
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
       // data,
        url:`${CONFIG.API_URL+URLS.pending_patient_narratives}/surgeon_id/${surgeon_id}/currentPage/${currentPage}/offset/${currentPage}/limit/${CONFIG.RECORDS_PER_PAGE}/active/0/clinic_id/${clinic_id}`
    };

    return await axios(requestOptions).then(res => {
        if (res.data.header.error == 0){

            // console.log('OK first API HIT for page: ',res);
    
            let AllData = res.data.body.details.data;
            AllData = decryptListResponse(AllData)
            res.data.body.details.data = AllData;
          //  console.log('Data obj ',DataObj)
        }
        return res;
    }).catch(err => {
        return err;
    });
}
function getAcceptedPatientsNarrative(surgeon_id , currentPage) {
    // let data = new FormData();
    // data.append('token',getAccessToken());
    // data.append('surgeon_id',surgeon_id);
    // data.append('currentPage',currentPage);
    // data.append('active',CONFIG.CONST_STATUS_ACTIVE);
    // data.append('offset',currentPage);
    // data.append('limit',CONFIG.RECORDS_PER_PAGE);
    let userData = getLoggedInData();
    let clinic_id = userData.clinic_id;

    let requestOptions = {
        method:'GET',
      //  data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.pending_patient_narratives}/surgeon_id/${surgeon_id}/currentPage/${currentPage}/offset/${currentPage}/limit/${CONFIG.RECORDS_PER_PAGE}/active/${CONFIG.CONST_STATUS_ACTIVE}/clinic_id/${clinic_id}`
        
        //url:`${CONFIG.API_URL+URLS.pending_patient_narratives}`
    };

    return axios(requestOptions).then(res => {
        
        let AllData = res.data.body.details.data;
        AllData = decryptListResponse(AllData)
        res.data.body.details.data = AllData;

        // console.log('getAcceptedPatientsNarrative API',res)
        return res;
    }).catch(err => {
        return err;
    });
}

function getPatientDetail(patient_id) {
    // let data = new FormData();
    // data.append('token',getAccessToken());
    // data.append('patient_id',patient_id);
   // console.log('API HIT getPatientDetail ')
    let requestOptions = {
        method:'GET',
        //data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.patient_detail}/${patient_id}`
    };

    return axios(requestOptions).then(res => {
        
        let AllData = res.data.body.details;
        AllData = decryptDetailResponse(AllData)
        res.data.body.details = AllData;

        // console.log('Here is Patient Detail API', res)
        return res;
    }).catch(err => {
        return err;
    });
}

function getPatientComplains(patient_id) {
    // let data = new FormData();
    // data.append('token',getAccessToken());
    // data.append('patient_id',patient_id);
    // console.log('Api hits getPatientComplains')
    let requestOptions = {
        method:'GET',
        //data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.patient_complains}/${patient_id}`
    };

    return axios(requestOptions).then(res => {
        // console.log('From here we get patient Complains', res)
        return res;
    }).catch(err => {
        return err;
    });
}


function approvedPatientNarrative(patient_id) {
    let data = new FormData();
    //data.append('token',getAccessToken());
    data.append('patient_id',patient_id);
    
    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.approvedPatientNarrative}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getPatientOptionsDetail(patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('patient_id',patient_id);
    console.log('API HIT getPatientOptionsDetail')
    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.patient_options_detail}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getPatientComplainDetail(patient_id,complain_id) {
    // let data = new FormData();
    // data.append('token',getAccessToken());
    // data.append('patient_id',patient_id);
    // data.append('complain_id',complain_id);
//    console.log('API HIT getPatientComplainDetail')


    let requestOptions = {
        method:'GET',
       // data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.patient_complain_detail}/patient_id/${patient_id}/complain_id/${complain_id}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getNarrativeQuestionsDetail(narrative_id) {
    // let data = new FormData();
    // data.append('token',getAccessToken());
    // data.append('narrative_id',narrative_id);
    console.log('API Hit getNarrativeQuestionsDetail')
    let requestOptions = {
        method:'GET',
        // data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.narrative_questions_detail}/${narrative_id}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function updatePatientNarrative(formData) {
    let data = new FormData();
   // data.append('token',getAccessToken());
    data.append('data',formData);

    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.update_patient_narrative}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function saveSearchQuestionOption(question_id,response,patient_id,complain_id,surgeon_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('question_id',question_id);
    data.append('response',response);
    data.append('patient_id',patient_id);
    data.append('complain_id',complain_id);
    data.append('surgeon_id',surgeon_id);

    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.save_search_question_option}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getAdditionalPatientNarrative(patient_id) {
    let data = new FormData();
    //data.append('token',getAccessToken());
    // data.append('patient_id',patient_id);
    console.log('API Hits getAdditionalPatientNarrative')
    let requestOptions = {
        method:'GET',
        // data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.get_additional_patient_narrative}/${patient_id}`
    };

    return axios(requestOptions).then(res => {
        // console.log('here is getAdditionalPatientNarrative API',res)

        return res;
    }).catch(err => {
        // console.log('here is getAdditionalPatientNarrative err',err)

        return err;
    });
}


function searchQuestion(complainId,keyword,patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('keyword',keyword);
    data.append('complain_id',complainId);
    data.append('patient_id',patient_id);
    
    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.search_question}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getProfile(id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('user_id',id);
    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.user_profile}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}
function deleteAdditionalInfo(id,additional_response) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('id',id);
    data.append('additional_response',additional_response);
    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.delet_additional_info}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}
function savePendingQuestion(complain_id,surgeon_id,title,response,patient_id) {
    let data = new FormData();
    data.append('token',getAccessToken());
    data.append('complain_id',complain_id);
    data.append('surgeon_id',surgeon_id);
    data.append('title',title);
    data.append('patient_id',patient_id);
    data.append('response',response);

    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.save_pending_question}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function login(userData)
{
    let data = new FormData();
    data.append('email',userData.email);
    data.append('password',userData.password);
    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.login}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

